import escapeRegExp from "lodash/escapeRegExp";
import findIndex from "lodash/findIndex";
import identity from "lodash/identity";
import debounce from "lodash/debounce";

const VTS = (window.vts = window.vts || {});

jQuery(function () {
  // Bail only on the v2 sign-in pages (which have their own module,
  // sign-in-v2.js) so the two flows never both bind. Every other authc-layout
  // page (v1 sign-in, forgot-password, confirmation, unlock, ...) is unaffected.
  if ($("form[data-form-type=sign_in_v2], form[data-form-type=sign_in_v2_email]").length > 0) {
    return;
  }

  let serviceProviderName;

  const emailDomainRegExp = function (domain) {
    return new RegExp("s*@" + escapeRegExp(domain) + "\\s*", "i");
  };

  const emailRegExp = function (email) {
    return new RegExp("s*" + escapeRegExp(email) + "s*", "i");
  };

  const emailIsValid = function (emailAddress) {
    return emailAddress.match(/^([^@\s]+)@((?:[-a-z0-9]+\.)+[a-z]{2,})$/i) != null;
  };

  let lastAuthMethodsEmail = null;
  let lastAuthMethodsRequest = null;

  const authMethodsFor = function (emailAddress) {
    if (emailAddress && emailIsValid(emailAddress)) {
      if (emailAddress !== lastAuthMethodsEmail) {
        lastAuthMethodsEmail = emailAddress;
        lastAuthMethodsRequest = $.get(
          "/authc/sso/enabled?" +
            $.param({
              email_address: emailAddress,
            })
        ).fail(function () {
          if (lastAuthMethodsEmail === emailAddress) {
            lastAuthMethodsEmail = null;
            lastAuthMethodsRequest = null;
          }
        });
      }

      return lastAuthMethodsRequest;
    } else {
      return null;
    }
  };

  const userHasSSO = function (emailAddress) {
    const request = authMethodsFor(emailAddress);

    if (!request) {
      return false;
    }

    return request.then(function (data) {
      return data["is_sso_enabled"];
    });
  };

  const userIsMriOnly = function (emailAddress) {
    const request = authMethodsFor(emailAddress);

    if (!request) {
      return false;
    }

    return request.then(function (data) {
      return data["is_mri_only"];
    });
  };

  const tweakForm = function (method) {
    signInMethods.forEach(function (signInMethod) {
      if (signInMethod.key !== method.key) {
        signInMethod.signInElement.addClass("hidden");
        signInMethod.signInElement.prop("disabled", true);
      }
    });

    method.signInElement.prop("disabled", false);
    return method.signInElement.removeClass("hidden");
  };

  const ssoMethod = {
    key: "sso",
    signInElement: $("[data-auth-method=sso]"),

    applies: function (emailAddress) {
      if (this.isVTSException(emailAddress)) {
        return false;
      }

      return userHasSSO(emailAddress);
    },

    signIn: function (event) {
      if (event.code === "Enter") {
        this.signInElement.submit();
      }

      return tweakForm(this);
    },

    vtsExceptions: [
      "sales@viewthespace.com",
      "sales@vts.com",
      "beta@vts.com",
      "super-beta@vts.com",
      "big@viewthespace.com",
      "availabilitiesonly@vts.com",
      "availabilitiesandexisting@vts.com",
    ].map(emailRegExp),

    isVTSException: function (emailAddress) {
      return this.vtsExceptions.some(function (exception) {
        return exception.test(emailAddress);
      });
    },
  };

  const mriMethod = {
    key: "mri",
    signInElement: $("[data-auth-method=mri]"),

    applies: function (emailAddress) {
      return userIsMriOnly(emailAddress);
    },

    signIn: function (event) {
      if (event.code === "Enter") {
        this.signInElement.submit();
      }

      return tweakForm(this);
    },
  };

  const passwordMethod = {
    key: "password",
    signInElement: $("[data-auth-method=password]"),

    applies: function () {
      return true;
    },

    signIn: function () {
      return tweakForm(this);
    },
  };

  const signInMethods = [mriMethod, ssoMethod, passwordMethod];

  const signInMethodListener = function (event) {
    let emailAddress = this.value;

    return $.when(
      ...signInMethods.map(function (method) {
        return method.applies(emailAddress);
      })
    ).then(function (...methodsApplies) {
      return signInMethods[findIndex(methodsApplies, identity)].signIn(event);
    });
  };

  $("form[data-form-type=sign_in]")
    .bind("ajax:success", function (evt, data) {
      if (data.disabled) {
        return VTS.setNotificationMessage({
          message: "Your account has been disabled. Please contact support@vts.com for assistance",
          selector: ".flash-message",
          type: "error",
        });
      } else if (data.unconfirmed) {
        return VTS.setNotificationMessage({
          message: "You have to confirm your account before continuing.",
          type: "error",
          selector: ".flash-message",
        });
      } else if (data.mri === true) {
        VTS.setNotificationMessage({
          message: "Redirecting you to the MRI portal.",
          selector: ".flash-message",
          type: "success",
        });

        return (window.location = data.location);
      } else if (data.sso === true) {
        VTS.setNotificationMessage({
          message: "Redirecting you to Single Sign On.",
          selector: ".flash-message",
          type: "success",
        });

        return (window.location = data.location);
      } else if (data.saml) {
        VTS.setNotificationMessage({
          message: "Redirecting you back to service provider",
          type: "success",
          selector: ".flash-message",
        });

        return (window.location = data.location);
      } else if (data.location != null) {
        return (window.location = data.location);
      }
    })
    .bind("ajax:error", function (evt, data) {
      return VTS.setNotificationMessage({
        message: data.responseJSON.error,
        selector: ".flash-message",
        type: "error",
      });
    })
    .bind("ajax:before", function () {
      return VTS.removeNotificationMessage({
        selector: ".flash-message",
      });
    });

  if (/[?&]unauthorized=t/.test(location.href)) {
    VTS.setNotificationMessage({
      message: "Please login to continue.",
      type: "error",
      selector: ".flash-message",
    });
  }

  if (/[?&]unlocked=t/.test(location.href)) {
    VTS.setNotificationMessage({
      message: "Your account was successfully unlocked.",
      type: "success",
      selector: ".flash-message",
    });
  }

  if (/[?&]timeout=t/.test(location.href)) {
    VTS.setNotificationMessage({
      message: "Your session expired, please sign in again to continue.",
      type: "error",
      selector: ".flash-message",
    });
  }

  if (/[?&]disabled=t/.test(location.href)) {
    VTS.setNotificationMessage({
      message: "Your account has been disabled. Please contact support@vts.com for assistance.",
      type: "error",
      selector: ".flash-message",
    });
  }

  if (/[?&]confirmation=t/.test(location.href)) {
    VTS.setNotificationMessage({
      message: "Confirmation token invalid.",
      type: "error",
      selector: ".flash-message",
    });
  }

  if (/[?&]SAMLRequest=/.test(location.href)) {
    if (
      (serviceProviderName = $("[data-saml-service-provider-name]").data(
        "saml-service-provider-name"
      ))
    ) {
      VTS.setNotificationMessage({
        message: "Please sign in to continue with " + serviceProviderName,
        type: "success",
        selector: ".flash-message",
      });
    }
  }

  const marketingLinks = {
    ".marketing-top":
      "https://vodi.vts.com/?utm_source=product-page&utm_medium=Website&utm_campaign=2026-April-VODI-Platform-Login",
    ".marketing-left":
      "https://www.vts.com/vts-activate-office?utm_medium=web&utm_source=vts-login",
    ".marketing-right":
      "https://www.vts.com/product/new-releases?utm_medium=web&utm_source=vts-login",
  };

  Object.entries(marketingLinks).forEach(([container, link]) => {
    $(container).click(() => {
      const hasLink = $(container).find("a").length;

      if (!hasLink) {
        window.open(link, "_blank");
      }
    });
  });

  var topWrapper = jQuery(".signIn-page");
  jQuery(".continue-to-web a").on("click", function () {
    topWrapper.addClass("mobile-continue");
  });

  $("#user_email").focus();
  return $("#user_email").on("keyup change", debounce(signInMethodListener, 150));
});
